<template>
  <div>
    <b-input-group size="sm">
      <b-input-group-prepend>
        <b-button variant="light" @click="showModal" :disabled="dropdownDisabled">
          <i class="lookup-dropdown--plus fa fa-plus"></i>
        </b-button>
      </b-input-group-prepend>

      <b-form-select :value="dropdownValue" @change="onChange" :disabled="dropdownDisabled">
        <option v-for="(item) in options" :key="item.id" :value="item.id">{{item.name}}</option>
      </b-form-select>
    </b-input-group>

    <b-modal
      :id="modalId"
      :ref="modalId"
      size="md"
      ok-title="Add"
      @ok="handleSubmit"
      :ok-disabled="!name"
    >
      <template slot="modal-header">
        <h5 class="modal-title">Add new {{ label }}</h5>
      </template>

      <form id="add-lookup-form">
        <b-form-group class="required" label="Name">
          <b-form-input v-model="name" type="text" size="sm"></b-form-input>
        </b-form-group>
      </form>
      <required-descriptor/>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    value: [String, Number],   // value is used for selecting right option in select box
    options: Array,            // options are the select box options
    propKey: String,           // propKey is the property key to be changed in parent's model
    label: String,             // label will be displayed in the modal header
    resource: String,          // resource determines the endpoint in the endpoints map
    moduleName: String,        // module defines the property in the vuex store where new item will be added
    dropdownDisabled: Boolean, // value is used for disabling dropdown and plus button
  },
  data: () => ({
    name: '',
  }),
  computed: {
    dropdownValue() {
      return this.value;
    },
    modalId() {
      return `${this.propKey}-modal`;
    },
  },
  methods: {
    ...mapActions('lookup', ['createLookup']),
    onChange(value) {
      const { propKey: name } = this;
      this.$emit('change', { name, value });
    },
    showModal: function() {
      this.$root.$emit('bv::show::modal', this.modalId);
    },
    async handleSubmit() {
      const { propKey, name, resource, moduleName } = this;
      const id = await this.createLookup({ resource, name, moduleName });
      this.$emit('change', { name: propKey, value: id });
    },
  },
};
</script>

<style lang="scss">
.lookup-dropdown {
  &--plus {
    font-size: 10px;
  }
}
</style>

